const COMMAND = {
  // 종목 상세
  OPEN_STOCK_DETAIL: 'mts_stock_detail',

  // 인증
  GET_ACCESS_TOKEN: 'paysec_access_token', // 증권 인증토큰
} as const;

export type CommandType = typeof COMMAND[keyof typeof COMMAND];

export default COMMAND;
